"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _Business = _interopRequireDefault(require("./Business"));
var _Customer = _interopRequireDefault(require("./Customer"));
var _Employee = _interopRequireDefault(require("./Employee"));
var _Group = _interopRequireDefault(require("./Group"));
var _OperatorLevel = _interopRequireDefault(require("./OperatorLevel"));
var _Role = _interopRequireDefault(require("./Role"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The Operator model module.
 * @module model/Operator
 * @version 3.0
 */
var Operator = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>Operator</code>.
   * @alias module:model/Operator
   */
  function Operator() {
    _classCallCheck(this, Operator);
    Operator.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(Operator, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>Operator</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Operator} obj Optional instance to populate.
     * @return {module:model/Operator} The populated <code>Operator</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new Operator();
        if (data.hasOwnProperty('organizationId')) {
          obj['organizationId'] = _ApiClient["default"].convertToType(data['organizationId'], 'Number');
        }
        if (data.hasOwnProperty('organizationLegacyId')) {
          obj['organizationLegacyId'] = _ApiClient["default"].convertToType(data['organizationLegacyId'], 'String');
        }
        if (data.hasOwnProperty('description')) {
          obj['description'] = _ApiClient["default"].convertToType(data['description'], 'String');
        }
        if (data.hasOwnProperty('operatorCode')) {
          obj['operatorCode'] = _ApiClient["default"].convertToType(data['operatorCode'], 'String');
        }
        if (data.hasOwnProperty('roles')) {
          obj['roles'] = _ApiClient["default"].convertToType(data['roles'], [_Role["default"]]);
        }
        if (data.hasOwnProperty('employees')) {
          obj['employees'] = _ApiClient["default"].convertToType(data['employees'], [_Employee["default"]]);
        }
        if (data.hasOwnProperty('customers')) {
          obj['customers'] = _ApiClient["default"].convertToType(data['customers'], [_Customer["default"]]);
        }
        if (data.hasOwnProperty('businesses')) {
          obj['businesses'] = _ApiClient["default"].convertToType(data['businesses'], [_Business["default"]]);
        }
        if (data.hasOwnProperty('groups')) {
          obj['groups'] = _ApiClient["default"].convertToType(data['groups'], [_Group["default"]]);
        }
        if (data.hasOwnProperty('levels')) {
          obj['levels'] = _ApiClient["default"].convertToType(data['levels'], [_OperatorLevel["default"]]);
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>Operator</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Operator</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['organizationLegacyId'] && !(typeof data['organizationLegacyId'] === 'string' || data['organizationLegacyId'] instanceof String)) {
        throw new Error("Expected the field `organizationLegacyId` to be a primitive type in the JSON string but got " + data['organizationLegacyId']);
      }
      // ensure the json data is a string
      if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
        throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
      }
      // ensure the json data is a string
      if (data['operatorCode'] && !(typeof data['operatorCode'] === 'string' || data['operatorCode'] instanceof String)) {
        throw new Error("Expected the field `operatorCode` to be a primitive type in the JSON string but got " + data['operatorCode']);
      }
      if (data['roles']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['roles'])) {
          throw new Error("Expected the field `roles` to be an array in the JSON data but got " + data['roles']);
        }
        // validate the optional field `roles` (array)
        var _iterator = _createForOfIteratorHelper(data['roles']),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            _Role["default"].validateJSON(item);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        ;
      }
      if (data['employees']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['employees'])) {
          throw new Error("Expected the field `employees` to be an array in the JSON data but got " + data['employees']);
        }
        // validate the optional field `employees` (array)
        var _iterator2 = _createForOfIteratorHelper(data['employees']),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _item = _step2.value;
            _Employee["default"].validateJSON(_item);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        ;
      }
      if (data['customers']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['customers'])) {
          throw new Error("Expected the field `customers` to be an array in the JSON data but got " + data['customers']);
        }
        // validate the optional field `customers` (array)
        var _iterator3 = _createForOfIteratorHelper(data['customers']),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _item2 = _step3.value;
            _Customer["default"].validateJSON(_item2);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
        ;
      }
      if (data['businesses']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['businesses'])) {
          throw new Error("Expected the field `businesses` to be an array in the JSON data but got " + data['businesses']);
        }
        // validate the optional field `businesses` (array)
        var _iterator4 = _createForOfIteratorHelper(data['businesses']),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _item3 = _step4.value;
            _Business["default"].validateJSON(_item3);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
        ;
      }
      if (data['groups']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['groups'])) {
          throw new Error("Expected the field `groups` to be an array in the JSON data but got " + data['groups']);
        }
        // validate the optional field `groups` (array)
        var _iterator5 = _createForOfIteratorHelper(data['groups']),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var _item4 = _step5.value;
            _Group["default"].validateJSON(_item4);
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
        ;
      }
      if (data['levels']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['levels'])) {
          throw new Error("Expected the field `levels` to be an array in the JSON data but got " + data['levels']);
        }
        // validate the optional field `levels` (array)
        var _iterator6 = _createForOfIteratorHelper(data['levels']),
          _step6;
        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var _item5 = _step6.value;
            _OperatorLevel["default"].validateJSON(_item5);
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
        ;
      }
      return true;
    }
  }]);
}();
/**
 * @member {Number} organizationId
 */
Operator.prototype['organizationId'] = undefined;

/**
 * @member {String} organizationLegacyId
 */
Operator.prototype['organizationLegacyId'] = undefined;

/**
 * @member {String} description
 */
Operator.prototype['description'] = undefined;

/**
 * @member {String} operatorCode
 */
Operator.prototype['operatorCode'] = undefined;

/**
 * @member {Array.<module:model/Role>} roles
 */
Operator.prototype['roles'] = undefined;

/**
 * @member {Array.<module:model/Employee>} employees
 */
Operator.prototype['employees'] = undefined;

/**
 * @member {Array.<module:model/Customer>} customers
 */
Operator.prototype['customers'] = undefined;

/**
 * @member {Array.<module:model/Business>} businesses
 */
Operator.prototype['businesses'] = undefined;

/**
 * @member {Array.<module:model/Group>} groups
 */
Operator.prototype['groups'] = undefined;

/**
 * @member {Array.<module:model/OperatorLevel>} levels
 */
Operator.prototype['levels'] = undefined;
var _default = exports["default"] = Operator;